import en from './en.json';
import de from './de.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import pt from './pt.json';
import nl from './nl.json';
import pl from './pl.json';
import cs from './cs.json';
import da from './da.json';
import fi from './fi.json';
import sv from './sv.json';
import no from './no.json';
import hu from './hu.json';
import ro from './ro.json';
import el from './el.json';
import id from './id.json';

const translations = {
  en,
  de,
  es,
  fr,
  it,
  pt,
  nl,
  pl,
  cs,
  da,
  fi,
  sv,
  no,
  hu,
  ro,
  el,
  id
};
export default translations;


